import {LiveFlightsRow} from "./types";
import {TableViewsContext} from "./table-views";

export default function singleView(dataSource: LiveFlightsRow[], context: TableViewsContext): LiveFlightsRow[]{
    return dataSource;
}